export default class HTTPError extends Error {
    constructor(status, statusText, url, message) {
        super(`${message}\n${status} ${statusText}: ${url}`);
        this.status = status;
        this.statusText = statusText;
        this.url = url;
        this.message = message;
    }

    get name() { return "HTTPError"; }
}